(() => {
  const frames = Array.from(document.querySelectorAll('.bud-tiktok__card iframe'));
  if (!frames.length) return;

  let activeFrame = null;

  const pauseFrame = (frame) => {
    if (!frame || !frame.contentWindow) return;

    try {
      frame.contentWindow.postMessage({ type: 'pause', 'x-tiktok-player': true }, '*');
    } catch (error) {
      // Cross-origin players can reject commands silently; the reload below is the fallback.
    }

    const src = frame.dataset.budSrc || frame.src;
    frame.dataset.budSrc = src;
    frame.src = 'about:blank';
    window.setTimeout(() => {
      if (frame !== activeFrame) frame.src = src;
    }, 80);
  };

  const activateFrame = (frame) => {
    if (!frame || frame === activeFrame) return;

    const previousFrame = activeFrame;
    activeFrame = frame;
    pauseFrame(previousFrame);
  };

  frames.forEach((frame) => {
    frame.dataset.budSrc = frame.src;

    frame.addEventListener('pointerdown', () => activateFrame(frame));
    frame.addEventListener('focus', () => activateFrame(frame));
  });

  window.addEventListener(
    'blur',
    () => {
      window.setTimeout(() => {
        const focusedFrame = document.activeElement;
        if (focusedFrame && frames.includes(focusedFrame)) activateFrame(focusedFrame);
      }, 0);
    },
    true
  );

  window.addEventListener('message', (event) => {
    const sourceFrame = frames.find((frame) => frame.contentWindow === event.source);
    if (!sourceFrame) return;

    let data = event.data;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        data = { type: data };
      }
    }

    const eventName = String(data?.type || data?.eventName || data?.name || '').toLowerCase();
    if (eventName.includes('play')) activateFrame(sourceFrame);
  });

  document.querySelectorAll('[data-bud-tiktok-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-bud-tiktok-viewport]');
    const rail = carousel.querySelector('.bud-tiktok__rail');
    const previous = carousel.querySelector('[data-bud-tiktok-prev]');
    const next = carousel.querySelector('[data-bud-tiktok-next]');
    if (!viewport || !rail || !previous || !next) return;

    const updateNav = () => {
      const atStart = viewport.scrollLeft <= 4;
      const atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;

      previous.disabled = atStart;
      next.disabled = atEnd;
      previous.classList.toggle('is-disabled', atStart);
      next.classList.toggle('is-disabled', atEnd);
    };

    const getStep = () => {
      const card = rail.querySelector('.bud-tiktok__card');
      if (!card) return viewport.clientWidth;

      const railStyle = window.getComputedStyle(rail);
      const gap = parseFloat(railStyle.columnGap || railStyle.gap || '0') || 0;
      const cardWidth = card.getBoundingClientRect().width;
      const visibleCards = Math.max(1, Math.floor((viewport.clientWidth + gap) / (cardWidth + gap)));

      return visibleCards * (cardWidth + gap);
    };

    const move = (direction) => {
      viewport.scrollBy({
        left: direction * getStep(),
        behavior: 'smooth',
      });
      window.setTimeout(updateNav, 260);
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    viewport.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  });
})();
